import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/product/stars.png")